// export const ProductsAPI = "http://localhost:8888/api/nike-store";
export const ProductsAPI = "/api/nike-store";